module.exports = __webpack_public_path__ + "img/folder.503b5e2a.svg";